import { useEffect } from "react";
import { useLanguage } from "../contexts/LanguageContext";
import { useModal } from "../contexts/ModalContext";

const excludedIds = new Set(["loginForm", "clientSignupForm", "professional-signup-form"]);

export default function DemoSubmissionListener() {
  const { t } = useLanguage();
  const { showModal } = useModal();

  useEffect(() => {
    const onSubmitCapture = (event) => {
      const form = event.target;
      if (!form || form.tagName !== "FORM") return;
      if (excludedIds.has(form.id)) return;
      showModal(t("demoSubmission"), "Preview Notice");
    };

    document.addEventListener("submit", onSubmitCapture, true);
    return () => {
      document.removeEventListener("submit", onSubmitCapture, true);
    };
  }, [showModal, t]);

  return null;
}
